import React from 'react';
import logo from '../img/csiLogo.png';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';


const Header = () => {
  return (
    <header className="text-gray-400 bg-black">
      <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center font-varelaround">
        <a className="flex title-font font-medium items-center text-white mb-4 md:mb-0">
          <img src={logo} className="h-12" alt="CSI Logo" />
          <span className="ml-3 text-xl font-ttsquare">CSI</span>
        </a>
        <nav className="md:ml-auto flex flex-wrap items-center text-base justify-center">
          <Link className="mr-5 hover:text-[#ff64c6]" to="/">
            Home
          </Link>
          <Link className="mr-5 hover:text-[#ff64c6]" to="/about">
            About
          </Link>
          <a className="mr-5 hover:text-[#ff64c6]" href="/publications">
            Publications
          </a>
          <a href="/contactus" className="mr-5 hover:text-[#ff64c6]">
            Contact Us
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
